import { render } from "./AiCustomerService.vue?vue&type=template&id=13d50a7c&scoped=true"
import script from "./AiCustomerService.vue?vue&type=script&lang=js"
export * from "./AiCustomerService.vue?vue&type=script&lang=js"

import "./AiCustomerService.vue?vue&type=style&index=0&id=13d50a7c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d50a7c"]])

export default __exports__